import { FC } from "react";
import { Navigate } from "react-router-dom";

/** Legacy `/register` bookmarks → unified auth page. */
export const RegisterRedirect: FC = () => (
  <Navigate to="/login?tab=register" replace />
);
